import { supabase } from './supabase';

export async function fetchPublishedNews() {
  const { data, error } = await supabase
    .from('news_posts')
    .select('*')
    .eq('status', 'published')
    .order('date', { ascending: false });
  if (error) throw error;
  return data;
}

export async function fetchAllNewsPosts() {
  const { data, error } = await supabase
    .from('news_posts')
    .select('*')
    .order('date', { ascending: false });
  if (error) throw error;
  return data;
}

export async function fetchNewsPostById(id) {
  const { data, error } = await supabase.from('news_posts').select('*').eq('id', id).single();
  if (error) throw error;
  return data;
}

export async function upsertNewsPost(post) {
  const { data, error } = await supabase.from('news_posts').upsert(post).select().single();
  if (error) throw error;
  return data;
}

export async function deleteNewsPost(id) {
  const { error } = await supabase.from('news_posts').delete().eq('id', id);
  if (error) throw error;
}

export async function fetchNewsImages(newsPostId) {
  const { data, error } = await supabase
    .from('news_images')
    .select('*')
    .eq('news_post_id', newsPostId)
    .order('sort_order', { ascending: true });
  if (error) throw error;
  return data;
}

export async function addNewsImage(newsPostId, imageUrl, sortOrder = 0) {
  const { data, error } = await supabase
    .from('news_images')
    .insert({ news_post_id: newsPostId, image_url: imageUrl, sort_order: sortOrder })
    .select()
    .single();
  if (error) throw error;
  return data;
}

export async function deleteNewsImage(id) {
  const { error } = await supabase.from('news_images').delete().eq('id', id);
  if (error) throw error;
}
